<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@300;400;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Do+Hyeon&display=swap');
@import url("https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css");
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700;900&display=swap');

*{
  font-family: 'Noto Sans KR', Helvetica, Arial, sans-serif;
  letter-spacing: -0.025rem;
}
#app {
  font-family: 'Noto Sans KR', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
}

pre {
  font-family: 'Noto Sans KR', Helvetica, Arial, sans-serif !important;
}

/*
=====================================
CSS RESET
=====================================
*/
html, body, div, span, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
abbr, address, cite, code,
del, dfn, em, img, ins, kbd, q, samp,
small, strong, sub, sup, var,
b, i,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, figcaption, figure,
footer, header, hgroup, menu, nav, section, summary,
time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
}

body {
  line-height: 1;
}

article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
  display: block;
}

ul li {
  list-style: none;
}

a {
  margin: 0;
  padding: 0;
  border: 0;
  vertical-align: baseline;
  background: transparent;
  text-decoration: none;
  color: inherit;
  display: inline-block;
}

img {
  vertical-align: bottom;
}

button {
  border: 0;
  cursor: pointer;
}

/*
=====================================
CUSTOM
=====================================
*/

.clearfix:after {
  content: "";
  display: block;
  clear: both;
}

.container-main {
  box-sizing: border-box;
  position: relative;
}

.header {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 9;
}

input {
  border: 1px solid #ddd;
}

.gamja-flower-regular {
  font-family: "Gamja Flower", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.do-hyeon-regular {
  font-family: "Do Hyeon", sans-serif;
  font-weight: 400;
  font-style: normal;
}


.nunito-font {
   font-family: "Nunito", sans-serif;
   font-optical-sizing: auto;
   font-weight: 700;
   font-style: normal;
 }


.fade-in-text {
  opacity: 0;
  transform: translateY(50px);
  //transition: opacity 1s ease-out, transform .5s ease-out;
  transition: opacity 1s ease-out, transform .5s ease-out;
}

.fade-in-text-slow {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 1s ease-out, transform .7s ease-out;
}

.fade-in-text.visible {
  opacity: 1;
  transform: translateY(0);
}

.slider {
  width: 300px;
  overflow: hidden;
  border: 1px solid #ddd;
  position: relative;
}

.slider-track {
  display: flex;
  transition: transform 0.5s ease;
}

.animated-text {
  font-size: 2em;
  font-weight: bold;
  position: relative;
  animation: moveAndFade 3s ease-in-out infinite;
}

.underline-animation {
  display: inline-block;
  position: relative;
  color: #333;
}

.underline-animation::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -8px; /* 밑줄과 텍스트 사이의 여백 추가 */
  width: 0;
  height: 2px; /* 밑줄 두께 */
  background-color: #00c5e3; /* 밑줄 색상 */
  transition: width 0.3s ease-in-out, left 0.3s ease-in-out; /* 너비와 위치에 대한 애니메이션 */
  transform: translateX(-50%);
  transform-origin: center; /* 변형 기준점을 중앙으로 설정 */
}

.underline-animation:hover::after {
  width: 100%; /* 호버 시 밑줄의 너비가 100%로 확장 */
  left: 50%; /* 중앙에서부터 확장되도록 위치 설정 */
  transform: translateX(-50%); /* 중앙에서 좌우로 확장되도록 설정 */
}

.container .title-box h2 {
  font-size: 46px;
  color: #333;
  font-weight: 700;
  text-decoration: underline;
  text-underline-position: under;
}

.container .title-box .sub-font {
  font-style: normal;
  margin-top: 25px;
  margin-bottom: 20px;
  font-weight: 400;
  color: #555;
  font-size: 17px;
}

.button-container {
  display: flex;
  justify-content: center; /* 수평 중앙 정렬 */
  align-items: center; /* 수직 중앙 정렬 */
  height: 100%; /* 필요에 따라 부모 컨테이너의 높이를 설정 */
  margin-top: 60px;
}

.button-container.left-align {
  justify-content: left;

}

.button-container button {
  box-sizing: border-box;
  padding: 15px 20px;
  border: 1px solid #eee;
  border-radius: 100px;
  font-size: 14px;
  background-color: #fff;

  cursor: pointer;
  display: flex;
  align-items: center; /* 버튼 안의 텍스트와 아이콘 수직 중앙 정렬 */
  justify-content: center; /* 버튼 안의 텍스트와 아이콘 수평 중앙 정렬 */

  transition: all 0.3s ease;
}

.button-container button:hover {
  background-color: #f0f0f0; /* 호버 효과 색상 */
}

.button-container button svg {
  width: 20px;
  height: 20px;
  margin-left: 10px;
}

.button-container button svg path {
  stroke: #00ade3;

}

@media screen and (max-width: 768px) {
  .button-container button {
    font-size: 13px !important;
  }
}

@keyframes moveAndFade {
  0% {
    left: 100%;
    opacity: 0;
  }
  50% {
    left: 50%;
    opacity: 1;
  }
  100% {
    left: 0;
    opacity: 0;
  }
}

@media screen and (max-width: 768px) {
  .container .title-box h2 {
    font-size: 38px;
  }
}

</style>
